import React, {useEffect} from 'react';
import {Modal} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {
    createNewInstallation,
    hideModal,
    updateInstallationItem
} from "../../redux-store/installations";
import {checkIsUpdate, editDataInstallation, modalVisibility} from "../../redux-store/selectors";
import ErrorIcon from "../../images/errorIcon.png";
import {REQUIRED_FIELD} from "../../constants/Messages";

const defaultValues = {"name": "", "description": ""}


const ModalComponent = () => {

    const {
        register,
        handleSubmit,
        formState: {errors, isSubmitSuccessful},
        setValue,
        reset
    } = useForm();
    const dispatch = useDispatch();
    const modalStatus = useSelector(modalVisibility)
    const editItemInstallation = useSelector(editDataInstallation)
    const checkIsUpdateForm = useSelector(checkIsUpdate)

    const handleCloseModal = () => {
        dispatch(hideModal())
        reset(defaultValues);
    }

    const handleSubmitForm = (data, e) => {
        e.preventDefault()
        if (checkIsUpdateForm) {
            dispatch(updateInstallationItem({data, id: editItemInstallation.id}))
        } else {
            dispatch(createNewInstallation(data))
        }
    }

    useEffect(() => {
        if (isSubmitSuccessful) {
            reset(defaultValues)
        }
    }, [isSubmitSuccessful])

    useEffect(() => {
        if (editItemInstallation !== undefined && Object.entries(editItemInstallation).length > 0) {
            setValue("name", editItemInstallation.name)
            setValue("description", editItemInstallation.description)
        }
    }, [editItemInstallation])

    return (
        <>
            <Modal
                show={modalStatus}
                onHide={handleCloseModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton className={"modal-header-component"}>
                    <Modal.Title>{"Instalacije"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit(handleSubmitForm)}>
                        <div className="mb-4">
                            <label className="mb-2 form-label" htmlFor="name">Ime instalacije</label>
                            <input type="text"
                                   className="form-control"
                                   name={"name"}
                                   {...register("name", {required: true})}/>
                            {errors.name && (
                                <span className="loggin-error"><img src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                            )}
                        </div>
                        <div className={"mb-3"}>
                            <div className="mb-2 w-100">
                                <label className="form-label" htmlFor="description">Kratak opis</label>
                            </div>
                            <textarea className="form-control" rows={"5"}
                                      name="description"
                                      {...register("description", {required: true})}/>
                            {errors.description && (
                                <span className="loggin-error"><img src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                            )}
                        </div>
                        <div className={"modal-footer-component"}>
                            <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                                {"Otkaži"}
                            </button>
                            <button
                                className={"btn btn-modal-confirm"}>{checkIsUpdateForm ? "Ažuriraj" : "Kreiraj"}</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ModalComponent;
